module.exports = __webpack_public_path__ + "static/media/success.1faeb2c8.svg";